import ConferenceService from '../services/ConferenceService';

export default class ConferencePresenter {

    constructor() {
        this.service = new ConferenceService();
    }

    async getConference() {
        return await this.service.getConference();
    }

}
